import React, { useState } from 'react';

const StreamingServiceIcon = ({ 
  service, 
  size = 'md', 
  showName = true,
  className = ''
}) => {
  const [imageError, setImageError] = useState(false);
  
  // Size configurations
  const sizeConfigs = {
    sm: { 
      container: 'w-4 h-4', 
      text: 'text-xs',
      fallback: 'text-xs'
    },
    md: { 
      container: 'w-8 h-8', 
      text: 'text-sm',
      fallback: 'text-sm'
    },
    lg: { 
      container: 'w-12 h-12', 
      text: 'text-base',
      fallback: 'text-base'
    }
  };
  
  const config = sizeConfigs[size] || sizeConfigs.md;

  // Callers resolve a service by id, and that lookup returns null for any id it
  // does not know - which real data contains, because some movies carry a raw
  // TMDB provider id rather than a mapped one. Dereferencing that null threw,
  // and with no error boundary above it the whole app went blank rather than
  // losing one small icon. A decorative badge must never be able to do that.
  if (!service) return null;

  const isImageUrl = service.logo && (service.logo.startsWith('http') || service.logo.startsWith('https'));
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Logo/Icon */}
      <div className={`${config.container} flex items-center justify-center rounded overflow-hidden`}>
        {isImageUrl && !imageError ? (
          <img
            src={service.logo}
            alt={`${service.name} logo`}
            className="w-full h-full object-contain"
            onError={() => setImageError(true)}
          />
        ) : (
          <span className={`${config.fallback} font-bold`}>
            {/* A half-formed service with no name must not crash either. */}
            {service.icon || service.logo || service.name?.charAt(0) || '📺'}
          </span>
        )}
      </div>
      
      {/* Service Name */}
      {showName && (
        <span className={`${config.text} font-medium text-gray-200`}>
          {service.name}
        </span>
      )}
    </div>
  );
};

export default StreamingServiceIcon;
